module.exports = __webpack_public_path__ + "img/brand--real-plaza.7a7aa3a4.png";